
// Global Variables
const desktop = window.matchMedia("(min-width: 991px)");
const mobile = window.matchMedia("(max-width: 768px)");
const scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement;

module.exports = { desktop, mobile, scrollElement }
